export default {
    get lxBreadcrumbsFirstItemTitle() {
        return 'Badoo Ins and Outs';
    },

    get lxShareArticleCta() {
        return 'Share this article';
    },

    lxArticleTitle(params: { name: string }) {
        return `More ${params.name} guides`;
    },
    // @TODO update after PRD update - stage 2
    get lxSeoPageTitle() {
        return 'Bumble - Date, Meet, Network Better';
    },

    get lxSeoPageDescription() {
        return 'Our mission is to create a world where all relationships are healthy and equitable. ';
    },

    get lxMoreArticlesCta() {
        return 'More articles';
    },
};
